var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatRemv4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1654 24.0833C31.1654 24.8348 30.8669 25.5555 30.3355 26.0868C29.8041 26.6182 29.0835 26.9167 28.332 26.9167H9.6717C8.92031 26.9168 8.19976 27.2154 7.66853 27.7468L4.54903 30.8663C4.40836 31.007 4.22915 31.1028 4.03406 31.1416C3.83896 31.1804 3.63674 31.1604 3.45297 31.0843C3.26919 31.0082 3.11211 30.8793 3.00159 30.7139C2.89106 30.5485 2.83206 30.3541 2.83203 30.1552V7.08333C2.83203 6.33189 3.13054 5.61122 3.6619 5.07986C4.19325 4.54851 4.91392 4.25 5.66536 4.25H28.332C29.0835 4.25 29.8041 4.54851 30.3355 5.07986C30.8669 5.61122 31.1654 6.33189 31.1654 7.08333V24.0833Z",
    stroke: "#4A1C22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 15.583H24.0846",
    stroke: "#4A1C22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 21.25H18.418",
    stroke: "#4A1C22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 9.91699H21.2513",
    stroke: "#4A1C22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRemv4);
export default __webpack_public_path__ + "static/media/chat-remv4.a2a971fef0598f633edcf78f384c88df.svg";
export { ForwardRef as ReactComponent };